"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _react = require("react");
var _constants = require("../constants");
var _constantsGenerated = require("../constants-generated");
var _logger2 = require("../logger");
var _InnerBasketItem = require("./InnerBasketItem");
var _jsxRuntime = require("react/jsx-runtime");
const BasketItem = ({
  translations,
  translationsNamespace,
  ...props
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const mergedTranslations = (0, _react.useMemo)(() => ({
    ..._constants.defaultTranslations,
    ...translations
  }), [translations]);
  const {
    code,
    bundleItems,
    lineNumber,
    testId,
    type
  } = props;
  const isBundle = Boolean(bundleItems && bundleItems.length > 0);
  const renderedItemType = isBundle ? 'bundle' : 'item';
  const itemTestId = `${testId}-${renderedItemType}-${code}-${type}`;
  const contextData = {
    ...props,
    itemTestId,
    isBundle,
    isBundleItem: false
  };
  (0, _logger2.logDebug)(`${lineNumber}-${code} context: `, contextData);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
    logger: _logger2.mainLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: `${_constantsGenerated.APP_NAME}-boundary`,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
        defaultTranslationsWithNamespaces: {
          [translationsNamespace]: _constants.defaultTranslations
        },
        language: language || 'en-GB',
        translationsWithNamespaces: {
          [translationsNamespace]: mergedTranslations
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
          namespace: translationsNamespace,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerBasketItem.InnerBasketItem, {
            data: contextData
          })
        })
      })
    })
  });
};
var _default = exports.default = BasketItem;
